<div class="w-full flex justify-center items-center mt-20">
    <div class="container m-auto flex justify-center items-center">
        <div class="flex flex-col items-center justify-center min-w-[1028px] px-12 py-6">
            <svg-icon svgClass="not-found-image" src="/assets/images/no-permission.svg"></svg-icon>
                <h5 class="max-w-[696px] text-center my-3" i18n="@@messages.no.permission">It doesn't look like you have the right permissions to view this page.</h5>
                <div class="my-3">
                    <p-button
                            severity="primary"
                            (click)="back()"
                            i18n-label="@@back.to.dashboard"
                            label="Back to Dashboard"
                
                    />
                </div>
        </div>
    </div> 
</div>